import { AssignmentTurnedIn } from "@gigpro/ui/Icons";
import { cn } from "@gigpro/ui/tailwind/cn";
import type React from "react";

type ProGigsWorkedProps = {
  gigsWorked: number;
  className?: string;
  iconClassName?: string;
};

export const ProGigsWorked: React.FC<ProGigsWorkedProps> = ({ gigsWorked, className, iconClassName }) => (
  <p className={cn("flex flex-row items-center gap-1", className)}>
    <AssignmentTurnedIn className={cn("size-3.5 self-center text-gray", iconClassName)} />
    <b>{gigsWorked ?? 0}</b> <span>shifts done</span>
  </p>
);
